import { Link, NavLink } from "react-router-dom";
import { Search, Heart, ShoppingBag, Menu, X } from "lucide-react";
import { useCart } from "@/contexts/CartContext";
import { useEffect, useState } from "react";
import { api } from "@/lib/api";

const BASE_NAV = [
  { to: "/looks", label: "Shop The Look", always: true },
  { to: "/new-in", label: "New In", always: true },
  { to: "/mood/work", label: "Work", mood: "work" },
  { to: "/mood/date", label: "Date", mood: "date" },
  { to: "/mood/weekend", label: "Weekend", mood: "weekend" },
  { to: "/about", label: "About", always: true },
  { to: "/contact", label: "Contact", always: true },
];

export default function Nav() {
  const { count, setOpen } = useCart();
  const [mobile, setMobile] = useState(false);
  const [moodCounts, setMoodCounts] = useState({});

  useEffect(() => {
    api.get("/moods").then(({ data }) => setMoodCounts(data || {})).catch(() => {});
  }, []);

  const NAV = BASE_NAV.filter(n => n.always || (moodCounts[n.mood] || 0) > 0);

  return (
    <header data-testid="site-nav" className="sticky top-0 z-40 backdrop-blur-xl border-b" style={{ background: "rgba(253,251,247,0.82)", borderColor: "#EBE5ED" }}>
      <div className="max-w-[1400px] mx-auto px-5 md:px-10 py-4 md:py-5 flex items-center justify-between gap-4">
        <button data-testid="nav-mobile-toggle" className="md:hidden -ml-1 p-2" onClick={() => setMobile(!mobile)} aria-label="Menu">
          {mobile ? <X size={20} strokeWidth={1.2} /> : <Menu size={20} strokeWidth={1.2} />}
        </button>

        <Link data-testid="nav-brand" to="/" className="font-serif-display text-[20px] md:text-[24px] tracking-brand text-[#4A464A] mx-auto md:mx-0">
          ONE LOOK
        </Link>

        <nav className="hidden md:flex items-center gap-7 text-[12px] uppercase tracking-editorial">
          {NAV.map(n => (
            <NavLink key={n.to} to={n.to} data-testid={`nav-${n.label.toLowerCase().replace(/\s+/g,'-')}`}
                     className={({ isActive }) => `hover:text-[#C3B1C5] transition-colors ${isActive ? "text-[#C3B1C5]" : "text-[#4A464A]"}`}>
              {n.label}
            </NavLink>
          ))}
        </nav>

        <div className="flex items-center gap-4 md:gap-5">
          <button data-testid="nav-search" className="hidden md:block" aria-label="Search"><Search size={18} strokeWidth={1.2} /></button>
          <Link data-testid="nav-wishlist" to="/wishlist" aria-label="Wishlist"><Heart size={18} strokeWidth={1.2} /></Link>
          <button data-testid="nav-cart" onClick={() => setOpen(true)} aria-label="Cart" className="relative">
            <ShoppingBag size={18} strokeWidth={1.2} />
            {count > 0 && <span className="absolute -top-2 -right-2 text-[10px] w-4 h-4 rounded-full flex items-center justify-center" style={{ background: "#C3B1C5", color: "#fff" }}>{count}</span>}
          </button>
        </div>
      </div>
      {mobile && (
        <div className="md:hidden border-t px-6 py-5 flex flex-col gap-4 text-[13px] uppercase tracking-editorial" style={{ borderColor: "#EBE5ED", background: "#FDFBF7" }}>
          {NAV.map(n => (
            <Link key={n.to} to={n.to} onClick={() => setMobile(false)} className="hover:text-[#C3B1C5]" data-testid={`mob-nav-${n.label.toLowerCase().replace(/\s+/g,'-')}`}>{n.label}</Link>
          ))}
        </div>
      )}
    </header>
  );
}
